export default function (state, val) {
  for (let k in val) {
    if (k === 'OwnerId') state.IsOwner = true;
    if (typeof state[k] !== 'undefined') state[k] = val[k];
  }
}